export const CHAMPION_IMAGE_PATH = '/-/media/Images/bg-champion-yellow.jpg';
export const FLAG_IMAGE_PATH = '/-/media/Images/flag-yellow.png';
export const ACTION_POST_BASE_URL = '/-/media/feature/livetext/actionposts';
export const TEXTSAFE_SFV_IMAGE_PATH = '../dist/images/text-safe-v4.png';
export const MULTIMEDIA_CAROUSEL_IMAGE_PATH = '/-/media/feature/MultimediaCarousel/MultimediaCarousel_Background';
export const PLAYER_SILHOUETTE_ON_SCORECARD = '/-/media/Feature/LivePlayer/default-cutout';
export const IS_HOLECARD_AVAILABLE = true;
export const ONE_CLUB_LABEL_DEFAULT = 'The One Club';
export const CLOUD_VIDEO_OBJECT_LOCAL_STORAGE = 'Cloud Video';
export const FEED_ID_LOCAL_STORAGE = 'Video Feed Id';

export const PLAYOFF_ROUND_ID = 401;
